import React, { useEffect, useState } from "react";
import styled from "@emotion/styled";
import ReactPixel from 'react-facebook-pixel';
import { useSendingLeadConversionAPI } from 'hooks/api';
import Cookies from 'js-cookie';


interface MetaPrams {
  source?: string,
  medium?: string,
  fbclid?: string,
  content?: string,
}

const Footer: React.FC= () => {
  const [param, setParam] = useState<MetaPrams>({
    source: "",
    medium: "",
    fbclid: "",
    content: "",
  });
  const { mutateAsync: postLeadConversionAPI  } = useSendingLeadConversionAPI();
  
  const getFbclidFromUrl = () => {
    const urlParams = new URLSearchParams(window.location.search);

    // return urlParams.get('fbclid');
    return {
      source: urlParams.get('utm_source') || "",
      medium: urlParams.get('utm_medium') || "",
      fbclid: urlParams.get('fbclid') || "",
      content: urlParams.get('utm_content') || ""
    }
  }

  useEffect(() => {
    const metaClickId = getFbclidFromUrl();
    if (metaClickId) {
      setParam(metaClickId)
    }
  },[]) 

  // const fbclid = param.fbclid;
  const source = param.source;
  const medium = param.medium;
  const content = param.content;

  const handleAppStore = async () => {
    const fbc = Cookies.get('_fbc') || "";
    // ReactPixel.fbq('track', 'Lead', {
    //   "type": "footer_app",
    //   "fbclid": fbclid,
    //   "source": source,
    //   "medium": medium,
    //   "content": content,
    //   "fbc": fbc
    // });

    ReactPixel.fbq('trackCustom', 'AppInstall', {
      "content_name": 'App Install',
      "content_category": 'Mobile App',
      "fbc": fbc,
      "store": 'appStore',
      "city": "KR",
      "gender" : "female"
    })
    // await postLeadConversionAPI({ fbclid, source, medium, content, fbc })
    window.open("https://apps.apple.com/kr/app/%ED%8F%AC%ED%8B%B0%ED%8E%98%ED%83%80-%ED%94%84%EB%A6%AC%EB%AF%B8%EC%97%84-%EC%9D%B8%ED%99%94%EA%B5%AC%EB%8F%85/id1619040733", "_blank")
  }

  const handleGoogle = async () => {
    const fbc = Cookies.get('_fbc') || "";

    const fbclid = param.fbclid;
    // ReactPixel.fbq('track', 'Lead', {
    //   "type": "footer_lead",
    //   "fbclid": fbclid,
    //   "source": source,
    //   "medium": medium,
    //   "content": content,
    //   "fbc": fbc,
      
    // });

    ReactPixel.fbq('trackCustom', 'AppInstall', {
      "content_name": 'App Install',
      "content_category": 'Mobile App',
      "fbc": fbc,
      "store": 'googlePlayStore',
      "city": "KR",
      "gender" : "female"
    })

    await postLeadConversionAPI({ fbclid, source, medium, content, fbc })
    window.open("https://play.google.com/store/apps/details?id=com.photypeta.photypetaApp", "_blank");
  }

  return (
    <Container>
      <FirstBox>
        <ImgBox>
          <Image src='/images/newLanding/home/logo_footer.png'></Image>
        </ImgBox>
      </FirstBox>
      <ContentsContainter>
        <HTextBox>
          <BoldText
            href='https://photypeta.oopy.io/terms'
          >이용약관</BoldText>
          <BoldText 
            href='https://photypeta.oopy.io/5ed1126f-4758-47fe-82ad-bf86c3467082'
            >개인정보 처리방침</BoldText>
        </HTextBox>
      </ContentsContainter>
      <SecondBox>
        <ContetBoxInSecondBox>
          <Text2>앱 다운로드</Text2>
          <DownloadBoxContainer>
            <DownloadBox className="app" onClick={handleAppStore}>
              <DownloadLogo>
                <Image src="/images/newLanding/home/appstoreicon.png"/>
              </DownloadLogo>
              APP STORE
            </DownloadBox>
            <DownloadBox className="googleButton" onClick={handleGoogle}>
              <DownloadLogo>
                <Image src="/images/newLanding/home/googleplayw.png"/>
              </DownloadLogo>
              GOOGLE PLAY
            </DownloadBox>
          </DownloadBoxContainer>
          <TextBoxInSecond>
            <Text2>주식회사 포티페타</Text2>            
            <Text3>대표자: 김중연
              <br/>사업자등록번호: 739-87-02408 &nbsp;&nbsp;&nbsp;&nbsp; 
              <br/>통신판매신고번호: 2022-서울성동-00372 
              <br/> 주소 : 서울특별시 성동구 성수일로 10길 26(성수동2가, 
              <br/>하우스디 세종타워), 10층 1001호
              <br/> 문의사항은 고객센터를 이용해 주세요
              <br/> 운영시간: 평일 10시 ~ 18시(점심시간: 12시 ~ 13시), 주말 휴무
            </Text3>
          </TextBoxInSecond>
          
        </ContetBoxInSecondBox>
      </SecondBox>
      <TextWrapper>
        <Text1>CopyRight ⒸPhotyPeta Inc. All rights reserved.</Text1>
      </TextWrapper>
    </Container>
  )
}

export default Footer;

const Container = styled.div`
  background-color: #2f2f2f;
  width: 100%;
  height: 100%;
  padding: 0 10px;
`
const ContentsContainter = styled.div`
  max-width: 1024px;
  height: 100%;
  margin: 0 auto;
  
  display: flex;
  flex-direction: row-reverse;
`
const FirstBox = styled.div`
  width: 100%;
  height: 70px;
  display: flex;
  align-items: end;
`;
const HTextBox = styled.div`
  width: 45%;
  height: 26px;
  margin-top: 10px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;
const BoldText = styled.a`
  color: white;
  font-family: 'Pretendard';
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
`;

const SecondBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  justify-content: space-between;
`

const ContetBoxInSecondBox = styled.div`
  width: 100%;
  margin-top: 22px;
  padding-left: 10px;
  display: flex;
  flex-direction: column;
`

const ImgBox = styled.div`
  height: 35px;
`
const Image = styled.img`
  height: 100%;
`

const TextBoxInSecond = styled.div`
  max-width: 567px;
  /* height: 149px; */
  width: 90%;
  margin-top: 48px;

  display: flex;
  flex-direction: column;
`
const Text3 = styled.p`
  font-size: 14px;
  font-weight: 400;
  margin-top: 0px;
  margin-bottom: 6px;
  color: white;
  white-space:nowrap;
  line-height: 1.4;
`

const Text2 = styled.div`
  width: 100%;
  height: 27px;
  color: white;
  font-size: 16px;
  font-weight: 600;
`

const DownloadBoxContainer = styled.div`
  width: 320px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

const DownloadBox = styled.button`
  margin-top: 10px;
  height: 50px;
  border: 1px solid white;
  border-radius: 5px;
  &.app{
    font-size: 14px;
    width: 150px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    color: white;
    background-color:#2f2f2f;
  }
  &.googleButton{
    font-size: 14px;
    width: 160px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    color: white;
    background-color:#2f2f2f;
  }
`;

const DownloadLogo = styled.div`
  width: 20px;
  height: 20px;
  margin-right: 10px;
`;

const TextWrapper = styled.div`
  display: flex;
  width: 100%;
  
  /* background-color: yellow; */
`

const Text1 = styled.div`
  color: white;
  font-size: 14px;
  margin: 10px auto 40px;
`;

